import { writable } from 'svelte/store';

// Store pour gérer l'état du layout
function createLayoutStore() {
    const { subscribe, set, update } = writable({
        fullWidth: false
    });

    return {
        subscribe,
        setFullWidth: (isFullWidth: boolean) => update(state => ({ ...state, fullWidth: isFullWidth })),
        reset: () => set({ fullWidth: false })
    };
}

export const layoutStore = createLayoutStore();